const modalCodes = {
    printableHistoryDetail: 'printableHistoryDetail',
    bingoBashMessageModal: 'bingoBashMessageModal',
    superBonusModal: 'superBonusModal',
    superSpinMessageModal: 'superSpinMessageModal',
    newSmsValidation: 'newSmsValidation',
    sdsSmsValidation: 'sdsSmsValidation',
    smsLimitReached: 'smsLimitReached',
    statusCode: 'statusCode',
    mobileStatusCode: 'mobileStatusCode',
    underAge: 'underAge',
    ticketSubmitRetry: 'ticketSubmitRetry',
    sessionDuration: 'sessionDuration',
    chooseGdpr: 'chooseGdpr',
    termsUpdate: 'termsUpdate',
    smsValidation: 'smsValidation',
    message: 'message',
    welcomeBonus: 'welcomeBonus',
    loyaltyShopBonus: 'loyaltyShopBonus',
    welcomeBonusIntro: 'welcomeBonusIntro',
    mobileBetSlip: 'mobileBetSlip',
    transactionHistory: 'transactionHistory',
    allTransactionHistory: 'allTransactionHistory',
    idCardVerificationApproved: 'idCardVerificationApproved',
    idCardVerificationApprovedGetId: 'idCardVerificationApprovedGetId',
    idCardVerification: 'idCardVerification',
    idCardVerificationIntro: 'idCardVerificationIntro',
    idCardVerificationIntroGetId: 'idCardVerificationIntroGetId',
    idCardVerificationReKyc: 'idCardVerificationReKyc',
    idCardVerificationPendingStatus: 'idCardVerificationPendingStatus',
    multiStepIdCardVerificationAddress: 'multiStepIdCardVerificationAddress',
    multiStepIdVerification: 'multiStepIdVerification',
    multiStepIdVerificationCamera: 'multiStepIdVerificationCamera',
    multiStepIdVerificationUpload: 'multiStepIdVerificationUpload',
    multiStepIdVerificationCollectData: 'multiStepIdVerificationCollectData',
    exitKyc: 'exitKyc',
    verificationKycSuccessful: 'verificationKycSuccessful',
    securityCheckIntro: 'securityCheckIntro',
    securityCheckError: 'securityCheckError',
    securityCheckSuccess: 'securityCheckSuccess',
    exitKycVerificationCaptive: 'exitKycVerificationCaptive',
    paymentIntro: 'paymentIntro',
    forgotPassword: 'forgotPassword',
    sdsForgotPassword: 'sdsForgotPassword',
    resetPassword: 'resetPassword',
    login: 'login',
    error: 'error',
    socialConfirmation: 'socialConfirmation',
    accountReopening: 'accountReopening',
    sdsAccountReopening: 'sdsAccountReopening',
    accountReopeningAgreement: 'accountReopeningAgreement',
    completeRegistration: 'completeRegistration',
    completeAccountActivation: 'completeAccountActivation',
    activationLinkExpired: 'activationLinkExpired',
    limitInformation: 'limitInformation',
    idTypeModalPicker: 'idTypeModalPicker',
    responsibleGamblingModal: 'responsibleGamblingModal',
    bonusCampaignModal: 'bonusCampaignModal',
    eligibleForCampaignModal: 'eligibleForCampaignModal',
    bonusStatusModal: 'bonusStatusModal',
    bonusAbuserModal: 'bonusAbuserModal',
    realityCheck: 'realityCheck',
    logoutDelay: 'logoutDelay',
    betBuilderConflict: 'betBuilderConflict',
    betBuilderOnboarding: 'betBuilderOnboarding',
    lastLogin: 'lastLogin',
    welcomeOffer: 'welcomeOffer',
    welcomeOfferError: 'welcomeOfferError',
    accountLocked: 'accountLocked',
    accountLockNotice: 'accountLockNotice',
    responsibleGamblingInfo: 'responsibleGamblingInfo',
    responsibleGamblingInfoBr: 'responsibleGamblingInfoBr',
    licencePreferences: 'licencePreferences',
    licenseRequired: 'licenseRequired',
    usernameUpdate: 'usernameUpdate',
    successModal: 'successModal',
    limitReached: 'limitReached',
    tooltipInfo: 'tooltipInfo',
    getIdVerification: 'getIdVerification',
    getIdVerificationPending: 'getIdVerificationPending',
    cashBonus: 'cashBonus',
    boostedOddConflict: 'boostedOddConflict',
    rgCloseAccount: 'rgCloseAccount',
    rgSelfExclusion: 'rgSelfExclusion',
    rgTimeOut: 'rgTimeOut',
    rgSetLimit: 'rgSetLimit',
    rgRemoveLimits: 'rgRemoveLimits',
    rgRealityCheckConfirmation: 'rgRealityCheckConfirmation',
    rgConfirmLimits: 'rgConfirmLimits',
    rgCancelLimit: 'rgCancelLimit',
    marketLineDescription: 'marketLineDescription',
    superAdvantageDescription: 'superAdvantageDescription',
    licenceMigration: 'licenceMigration',
    migrationSuccess: 'migrationSuccess',
    migrationUnderage: 'migrationUnderage',
    setFeatureBranch: 'setFeatureBranch',
    pushNotification: 'pushNotification',
    exitRegister: 'exitRegister',
    mfaCode: 'mfaCode',
    smsVerify: 'smsVerify',
    geoLocationCheck: 'geoLocationCheck',
    annualDataValidationModal: 'annualDataValidationModal',
    personalDataValidationModal: 'personalDataValidationModal',
    closeAccountMfa: 'closeAccountMfa',
    reactivationMailOtp: 'reactivationMailOtp',
    otpLogin: 'otpLogin',
    mfaPreferenceOtp: 'mfaPreferenceOtp',
    mfaPreferenceStatus: 'mfaPreferenceStatus',
    disableMfaPreference: 'disableMfaPreference',
    SuperBonusV2WelcomeModal: 'SuperBonusV2WelcomeModal',
    captiveKycRequired: 'captiveKycRequired',
    captiveKycPending: 'captiveKycPending',
    superBonusV2Modal: 'superBonusV2Modal',
    brazilMigrationTerms: 'brazilMigrationTerms',
    sportSelectDrawer: 'sportSelectDrawer',
    surveyModalCode: 'surveyModalCode',
} as const;

export default modalCodes;
